import { Host } from '@/models/host';
import { User } from '@/models/user';

type GetCategoryUrlArgs = {
    hasAbRank?: boolean;
    fixedPosition?: boolean;
    boostRankingVersion?: string;
    boostRanking?: string;
    category: string;
    start: string;
    length: string;
};

export function getCategoryUrl(args: GetCategoryUrlArgs): string {
    const {
        hasAbRank = false,
        fixedPosition = false,
        boostRankingVersion = '',
        boostRanking = '',
        category,
        start,
        length,
    } = args;

    const user = User.getInstance();
    const host = Host.getInstance();

    const adb = localStorage?.app_ad_block ? '1' : '';
    const quizAnswers = localStorage?.quiz_answers || '';

    let partner_desc = '';
    let is_partner_desc_marketing_prop = '';
    if (
        window['__dyanmic_template_props__'] &&
        window['__dyanmic_template_props__']['Settings']
    ) {
        const settings = window['__dyanmic_template_props__']['Settings'];
        partner_desc = settings['partnerDescProp'] ?? '';
        is_partner_desc_marketing_prop =
            settings['isPartnerDescMarketingProp'] == true
                ? settings['isPartnerDescMarketingProp']
                : '';
    }

    const queryArgs = new URLSearchParams({
        arnk: hasAbRank ? '1' : '0',
        t: user.token,
        fp: fixedPosition ? '1' : '0',
        uT: user.timezone,
        brnkv: boostRankingVersion,
        brnk: boostRanking && '1',
        clId: user.clickinId,
        uA: user.age,
        uG: user.gender,
        adb,
        quiz_answers: quizAnswers,
        device_type: user.deviceType,
        template: host.template,
        remove_clickout_links: '1',
        remove_null_props: '1',
        remove_summary: '1',
        partner_desc,
        is_partner_desc_marketing_prop,
        start,
        length,
    }).toString();

    return `/host/${host.id}/category/${user.trafficSource}/${category}?${queryArgs}`;
}
